import { ThreeStateCustomToggleButtonComponent } from './three-state-custom-toggle-button/three-state-custom-toggle-button.component';
import { Injector, NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MAT_MOMENT_DATE_FORMATS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatTreeModule } from '@angular/material/tree';

import {
  AccordionModule,
  BsDropdownModule,
  ButtonsModule,
  CarouselModule,
  CollapseModule,
  DatepickerModule,
  ModalModule,
  PaginationModule,
  PopoverModule,
  ProgressbarModule,
  RatingModule,
  SortableModule,
  TabsModule,
  TimepickerModule,
  TooltipModule,
  TypeaheadModule,
} from 'ngx-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AgGridModule } from '@ag-grid-community/angular';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { TreeGridModule } from '@syncfusion/ej2-angular-treegrid';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxCaptureModule, NgxCaptureService } from 'ngx-capture';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
} from 'ngx-perfect-scrollbar';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { NgxPowerBiModule, NgxPowerBiService } from 'ngx-powerbi';
import { MsalModule } from '@azure/msal-angular';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgxLoadingModule } from 'ngx-loading';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {
  ChildItemActionCellRenderer,
  ChildItemEditRenderer,
  MasterItemActionCellRenderer,
  MasterItemEditRenderer,
  PromotionItemEditRenderer,
  PromotionPlannerEditRenderer
} from '../modules/item-manager/features';
import { FusionChartsModule } from 'angular-fusioncharts';
// Import FusionCharts library and chart modules
import * as FusionCharts from 'fusioncharts';
import * as charts from 'fusioncharts/fusioncharts.charts';
import * as FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
FusionChartsModule.fcRoot(FusionCharts, charts, FusionTheme);
import { TreeviewModule } from 'ngx-treeview';
import { AGDatePickerComponent } from 'src/common/ag-date-cell-editor';
import { AGNumberEditorComponent } from 'src/common/ag-number-cell-editor';
import { PrivilegeErrorComponent } from 'src/common/privilege-error/privilege-error.component';

import { environment } from 'src/environments/environment';
import { MaterialModule } from './material.module';
import { AuthenticationService } from 'src/services/Authentication-Services/authentication-services';
import { UsersService } from 'src/services/User-services/user-services';
import { AddButtonRendererComponent } from 'src/common/add-button-renderer';
import { EditButtonRendererComponent } from 'src/common/edit-button-renderer';
import { ImageRendererComponent } from 'src/common/image-renderer';
import { NameRendererComponent } from 'src/common/name-renderer';
import { ViewRendererComponent } from 'src/common/view-renderer';
import { TreeviewDropdownComponent } from 'src/modules/facebook/features/treeview-dropdown/treeview-dropdown.component';
import { HttpInterceptorService } from 'src/services/http-interceptor.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomHeaderComponent } from 'src/common/custom-header.component';
import { CustomColumHeaderComponent } from 'src/common/custom-column-header';
import { ButtonRendererComponent } from 'src/common/button-renderer.component';
import { ConfirmationDialogComponent } from 'src/common/confirmation-dialog/confirmation-dialog.component';
import { LineChartComponent } from 'src/modules/layout/features/charts/line-chart/line-chart.component';
import { CloneRendererComponent } from 'src/common/clone-renderer';
import { ToggleButtonRendererComponent } from 'src/common/toggle-button-renderer';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CheckboxRendererComponent } from 'src/common/checkbox-renderer';
import {
  ChildItemService,
  ItemManagerService,
  ItemPromotionService,
  MasterProductService,
  PromotionPlannerService
} from 'src/services/Item-Management-Services';
import { AGColumnDialogComponent } from '../common/ag-column-dialog/ag-column-dialog.component';
import { CheckboxRenderer } from 'src/common/ag-checkbox-renderer';
import { DropdownRendererComponent } from 'src/common/dropdown-renderer';
import { UserPreferenceService } from 'src/services/User-services/user-preference.service';
import { BlobStorageService } from 'src/services/azure-storage/blob-storage.service';
import { BLOB_STORAGE_TOKEN, IAzureStorage } from 'src/services/azure-storage/azure-storage';
import { MomentUtcDateAdapter } from './moment-adapter';
import { AgGridDatePickerRenderer } from 'src/modules/apparel/business-metadata/ag-grid/agGridDatePickerRenderer';
import { RetailCalendarComponent } from 'src/common/retail-calendar/retail-calendar.component';
import { UpdateNameDialogComponent } from 'src/common/update-name-dialog/update-name-dialog.component';
import {
  CommitActionCellRenderer,
  DepromoWeekCellEditor,
  ForecastManagerEditRenderComponent,
  ForecastDataManagerEditRenderComponent,
  OutlierCustomHeaderGroup,
  PromoItemsEditRenderer,
  SeasonalityEditRenderer,
  SeasonalityLineChartCellRenderer
} from 'src/modules/forecast-engin/features';
import { OutlierService } from 'src/services/forecast-services/outlier-service';
import { OutlierLineChartCellRenderer } from 'src/modules/forecast-engin/features/outlier-manager/ag-grid/outlier-line-chart-cell-renderer.component';
import { MappingService } from 'src/services/forecast-services/mapping-service';
import { PromoService } from 'src/services/forecast-services/promo-service';
import { ForecastLookupService } from 'src/services/forecast-services/forecast-lookup-service';
import { SeasonalityService } from 'src/services/seasonality-services/seasonality.service';
import { ForecastManagerService } from 'src/services/forecast-services/forecast-manager.service';
import { TreeViewAccountDropdownComponent } from './select-account/treeview-account-dropdown.component';
import { TreeViewItemHierarchyDropdownComponent } from './select-product-hierarchy/treeview-product-hierarchy-dropdown.component';
import { DemoService } from 'src/services/demo-services/demo-service';
import { ClientPreferenceService } from 'src/services/client-services/client-preference.service';
import { MultiDatepickerModule } from 'src/common/multidatepicker/multidatepicker.module';
import { AgGridLineChartCellRenderer } from 'src/modules/replenishment-module/ag-grid/ag-grid-line-chart-cell-renderer.component';

declare var AzureStorage: IAzureStorage;
export let AppInjector: Injector;

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};
@NgModule({
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    BsDropdownModule.forRoot(),
    AccordionModule.forRoot(),
    ButtonsModule.forRoot(),
    CarouselModule.forRoot(),
    CollapseModule.forRoot(),
    DatepickerModule.forRoot(),
    ModalModule.forRoot(),
    PaginationModule.forRoot(),
    PopoverModule.forRoot(),
    ProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    SortableModule.forRoot(),
    TabsModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    ToastrModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    AgGridModule.withComponents([
      CustomHeaderComponent,
      ButtonRendererComponent,
      MasterItemEditRenderer,
      ChildItemEditRenderer,
      PromotionItemEditRenderer,
      AGDatePickerComponent,
      AGNumberEditorComponent,
      CheckboxRenderer,
      ChildItemActionCellRenderer,
      MasterItemActionCellRenderer,
      PromotionPlannerEditRenderer,
      DropdownRendererComponent,
      AgGridDatePickerRenderer,
      CommitActionCellRenderer,
      OutlierLineChartCellRenderer,
      PromoItemsEditRenderer,
      DepromoWeekCellEditor,
      SeasonalityEditRenderer,
      ForecastManagerEditRenderComponent,
      ForecastDataManagerEditRenderComponent,
      SeasonalityLineChartCellRenderer,
      OutlierCustomHeaderGroup,
      AgGridLineChartCellRenderer
    ]),
    AgGridModule.forRoot(),
    TreeViewModule,
    TreeGridModule,
    CKEditorModule,
    NgxCaptureModule,
    NgxDropzoneModule,
    NgxChartsModule,
    PerfectScrollbarModule,
    HttpClientModule,
    BsDropdownModule,
    MaterialModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    NgxPowerBiModule,
    NgMultiSelectDropDownModule.forRoot(),
    // NgChartjsModule,
    MsalModule.forRoot({
      auth: {
        clientId: 'dfc12811-de08-434f-b673-46b94ea8b892',
      },
    }),
    NgxLoadingModule,
    MatTreeModule,
    FusionChartsModule,
    TreeviewModule.forRoot(),
    HttpClientModule,
    CdkTreeModule,
    MultiDatepickerModule,
  ],
  providers: [
    AuthenticationService,
    UsersService,
    UserPreferenceService,
    DatePipe,
    NgxCaptureService,
    NgxPowerBiService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentUtcDateAdapter },

    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    CurrencyPipe,
    ItemManagerService,
    ChildItemService,
    MasterProductService,
    ItemPromotionService,
    PromotionPlannerService,
    BlobStorageService,
    {
      provide: BLOB_STORAGE_TOKEN,
      useValue: AzureStorage.Blob
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    OutlierService,
    MappingService,
    PromoService,
    SeasonalityService,
    ForecastLookupService,
    ForecastManagerService,
    DemoService,
    ClientPreferenceService,
  ],
  declarations: [
    CustomHeaderComponent,
    ButtonRendererComponent,
    CustomColumHeaderComponent,
    ConfirmationDialogComponent,
    EditButtonRendererComponent,
    NameRendererComponent,
    ViewRendererComponent,
    MasterItemEditRenderer,
    ChildItemEditRenderer,
    PromotionItemEditRenderer,
    AGDatePickerComponent,
    AGNumberEditorComponent,
    ImageRendererComponent,
    AddButtonRendererComponent,
    TreeviewDropdownComponent,
    ChildItemActionCellRenderer,
    MasterItemActionCellRenderer,
    PromotionPlannerEditRenderer,
    PrivilegeErrorComponent,
    LineChartComponent,
    CloneRendererComponent,
    ToggleButtonRendererComponent,
    CheckboxRendererComponent,
    AGColumnDialogComponent,
    CheckboxRenderer,
    DropdownRendererComponent,
    AgGridDatePickerRenderer,
    RetailCalendarComponent,
    UpdateNameDialogComponent,
    CommitActionCellRenderer,
    OutlierLineChartCellRenderer,
    PromoItemsEditRenderer,
    DepromoWeekCellEditor,
    SeasonalityEditRenderer,
    TreeViewAccountDropdownComponent,
    TreeViewItemHierarchyDropdownComponent,
    ForecastManagerEditRenderComponent,
    ForecastDataManagerEditRenderComponent,
    SeasonalityLineChartCellRenderer,
    OutlierCustomHeaderGroup,
    AgGridLineChartCellRenderer,
    ThreeStateCustomToggleButtonComponent
  ],
  exports: [
    BsDropdownModule,
    AccordionModule,
    ButtonsModule,
    CarouselModule,
    CollapseModule,
    DatepickerModule,
    ModalModule,
    PaginationModule,
    PopoverModule,
    ProgressbarModule,
    RatingModule,
    SortableModule,
    TabsModule,
    TimepickerModule,
    TooltipModule,
    TypeaheadModule,
    CommonModule,
    ToastrModule,
    AgGridModule,
    TreeViewModule,
    TreeGridModule,
    CustomHeaderComponent,
    CustomColumHeaderComponent,
    CKEditorModule,
    NgxCaptureModule,
    NgxDropzoneModule,
    NgxChartsModule,
    PerfectScrollbarModule,
    HttpClientModule,
    BsDropdownModule,
    MaterialModule,
    AngularFireModule,
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    NgxPowerBiModule,
    MsalModule,
    NgxSpinnerModule,
    FormsModule,
    ReactiveFormsModule,
    NgxLoadingModule,
    ConfirmationDialogComponent,
    EditButtonRendererComponent,
    NameRendererComponent,
    ViewRendererComponent,
    NgMultiSelectDropDownModule,
    MasterItemEditRenderer,
    ChildItemEditRenderer,
    MatTreeModule,
    FusionChartsModule,
    TreeviewModule,
    PromotionItemEditRenderer,
    AGDatePickerComponent,
    AGNumberEditorComponent,
    TreeviewDropdownComponent,
    ChildItemActionCellRenderer,
    MasterItemActionCellRenderer,
    PromotionPlannerEditRenderer,
    PrivilegeErrorComponent,
    HttpClientModule,
    CustomHeaderComponent,
    ButtonRendererComponent,
    CustomColumHeaderComponent,
    EditButtonRendererComponent,
    NameRendererComponent,
    ViewRendererComponent,
    ImageRendererComponent,
    AddButtonRendererComponent,
    LineChartComponent,
    CloneRendererComponent,
    ToggleButtonRendererComponent,
    CdkTreeModule,
    CheckboxRendererComponent,
    AGColumnDialogComponent,
    CheckboxRenderer,
    DropdownRendererComponent,
    AgGridDatePickerRenderer,
    RetailCalendarComponent,
    UpdateNameDialogComponent,
    CommitActionCellRenderer,
    OutlierLineChartCellRenderer,
    PromoItemsEditRenderer,
    DepromoWeekCellEditor,
    SeasonalityEditRenderer,
    TreeViewAccountDropdownComponent,
    TreeViewItemHierarchyDropdownComponent,
    ForecastManagerEditRenderComponent,
    ForecastDataManagerEditRenderComponent,
    SeasonalityLineChartCellRenderer,
    MultiDatepickerModule,
    OutlierCustomHeaderGroup,
    AgGridLineChartCellRenderer,
    ThreeStateCustomToggleButtonComponent
  ],
  entryComponents: [
    CustomHeaderComponent,
    ButtonRendererComponent,
    CustomColumHeaderComponent,
    ConfirmationDialogComponent,
    EditButtonRendererComponent,
    NameRendererComponent,
    ViewRendererComponent,
    MasterItemEditRenderer,
    ChildItemEditRenderer,
    PromotionItemEditRenderer,
    AGDatePickerComponent,
    AGNumberEditorComponent,
    ImageRendererComponent,
    AddButtonRendererComponent,
    TreeviewDropdownComponent,
    ChildItemActionCellRenderer,
    MasterItemActionCellRenderer,
    PromotionPlannerEditRenderer,
    PrivilegeErrorComponent,
    LineChartComponent,
    CloneRendererComponent,
    ToggleButtonRendererComponent,
    AGColumnDialogComponent,
    DropdownRendererComponent,
    AgGridDatePickerRenderer,
    RetailCalendarComponent,
    UpdateNameDialogComponent,
    CommitActionCellRenderer,
    OutlierLineChartCellRenderer,
    PromoItemsEditRenderer,
    DepromoWeekCellEditor,
    SeasonalityEditRenderer,
    TreeViewAccountDropdownComponent,
    TreeViewItemHierarchyDropdownComponent,
    ForecastManagerEditRenderComponent,
    ForecastDataManagerEditRenderComponent,
    SeasonalityLineChartCellRenderer,
    OutlierCustomHeaderGroup,
    AgGridLineChartCellRenderer
  ],
})
export class SharedModule {
  constructor(private injector: Injector) {
    AppInjector = this.injector;
  }
}
